// extracted by mini-css-extract-plugin
export default {"orderItem":"OrderItem_orderItem__uFKKo","itemName":"OrderItem_itemName__VxSx-","price":"OrderItem_price__ZdAGO"};